export const replaceDotByComma = (number, fixed, lang) => {
  if (typeof number !== 'number') number = +number
  if (lang?.toLowerCase() === 'fr') {
    return number.toFixed(fixed).replace('.', ',')
  }
  return number.toFixed(fixed)
}
